import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { Icon, IconInfoCircle, IconRegistryService } from "pax-ui/icons";

@Component({
  selector: "pax-help-dialog-button",
  standalone: true,
  imports: [CommonModule, Icon],
  templateUrl: "./help-dialog-button.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpDialogButtonComponent {
  @Input()
  label: string | undefined;

  @Input({ required: true })
  dialogPosition!: HelpDialogPosition;

  @Output()
  openDialog = new EventEmitter<void>();

  constructor(iconRegistryService: IconRegistryService) {
    iconRegistryService.registerIcons([IconInfoCircle]);
  }
}

export type HelpDialogPosition = "right" | "below";
